<template>
  <div>
    <b-row>
      <b-col>
        <div class="d-flex">
          <h3>Endereço</h3>
          <div class="ml-auto">
            <b-form-checkbox
              v-model="concedente.sem_endereco"
              class="input-sem-endereco"
            >
              Sem endereço
            </b-form-checkbox>
          </div>
        </div>
        <hr class="mt-0 mb-3" />
        <Endereco
          v-model="concedente.endereco"
          ref="endereco"
          v-if="!concedente.sem_endereco"
          :numero_required="false"
        />
        <div v-else>
          <h5 class="text-center p-4">Sem endereço</h5>
        </div>
      </b-col>
      <b-col>
        <h3>Telefone e Mídias Sociais</h3>
        <hr class="mt-0 mb-3" />
        <Contatos v-model="concedente.contatos" ref="contatos" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";
import { mapState } from "vuex";

export default {
  components: { Endereco, Contatos },
  data: () => ({
    validations: {
      endereco: true,
      contatos: true,
    },
  }),

  computed: {
    ...mapState("concedentes", ["concedente"]),
  },
  methods: {
    isValid() {
      this.validations.endereco = this.concedente.sem_endereco
        ? true
        : this.$refs.endereco.isValid();
      this.validations.contatos = this.$refs.contatos.isValid();

      return Object.values(this.validations).every(Boolean);
    },
  },
  created() {},
};
</script>

<style lang="scss">
.input-sem-endereco {
  .custom-control-label {
    padding-right: 2em;
    font-size: 0.8em !important;

    &::before,
    &::after {
      left: inherit;
      right: 0px;
    }
  }
}
</style>
